import { BookingSlot } from '../models/booking-slot';

export class BookingSlotHelper {
  static getOrderedSlots(
    slots: BookingSlot[],
    timeMinutes: number,
    productsCount: number = 0,
    offset: number = 0)
    : BookingSlot[] {

    if (!slots || slots.length < 0) {
      return new Array<BookingSlot>();
    }

    const slotIds = new Map<number, [number, BookingSlot]>();

    slots.forEach(areaSlot => {
      if (!slotIds.has(areaSlot.fromTime)) {
        slotIds.set(areaSlot.fromTime, [null, null]);
      }

      slotIds.set(areaSlot.fromTime, [areaSlot.areaId, areaSlot]);
    });

    const result = new Array<BookingSlot>();

    slotIds.forEach(val1 => {
      if (val1[1]) {
        result.push(val1[1]);
      }
    });

    return result;
  }

  private static _isTimeInContinuousTimes(
    continuousTimes: Array<[number, number]>,
    startTime: number,
    endTime: number)
    : boolean {
    return continuousTimes.findIndex(x => x[0] <= startTime && endTime <= x[1]) >= 0;
  }

  private static _calculateSummarySlotFreeTimes(
    slots: BookingSlot[],
    productsCount: number
  ): Array<[number, number]> {
    if (!slots) {
      return new Array<[number, number]>();
    }

    return slots.reduce((result, currentSlot, i) => {
      const nextSlot = slots[i + 1];
      const isFull = currentSlot.freeQuantity < productsCount;

      if (!isFull) {
        if (!result.length) {
          result.push([currentSlot.fromTime, null]);
        }

        result[result.length - 1][1] = currentSlot.toTime;
      }

      if (!nextSlot) {
        return result;
      }

      if (currentSlot.toTime !== nextSlot.fromTime || isFull) {
        result.push([nextSlot.fromTime, null]);
      }

      return result;
    }, Array<[number, number]>());
  }
}
